export default {
  news: [],
  highlightedNews: [],
  mainNews: null,
  newsInfos: {
    id: null,
    headline: null,
    slug: null,
    subtitle: null,
    content: null,
    hidden_content: null,
    thumbnail: null,
    call: null,
    activated: null,
    category: {
      id: null,
      name: null
    },
    author: {
      id: null,
      name: null,
      email: null,
      role: {
        id: null,
        name: null
      },
      social_networks: {
        facebook: null,
        twitter: null,
        instagram: null
      }
    },
    expanded_qty: 0
  },
  totalPages: 1
}
